import BaseModelAPI from '../BaseModelAPI';

export default class ApprovalStructure extends BaseModelAPI {
	static entity = 'approvalstructure';
	static entityName = 'approvalstructure';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.description = '';
			this.parentId = '';
			this.parent = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}